import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { endpoints } from 'modules/endpoints'
import { RequestError } from 'modules/errors'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { SharedModalTitle } from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import { RailwayRouteDTO, RatesProductTypes } from '../../types'
import { RailsModalContent } from './RailsModalContent'

interface Props {
  refetch: () => void
  onClose: () => void
  currentProductType: RatesProductTypes
}

export const AddRailsRatesModal: FC<Props> = ({ onClose, refetch, currentProductType }) => {
  const { formProgress, formHandler } = useAFormHandler('editRates')
  const { t } = useTranslation('rates')

  const formik = useFormik<Nullable<RailwayRouteDTO>>({
    initialValues: {
      from_station: null,
      to_station: null,
      rate: null,
      comment: '',
      product_type: currentProductType,
      product: null,
      rail_car_owner: null,
      rail_car_type: '',
      start_date: null,
      end_date: null,
      rail_car_load_limit: null,
    },

    onSubmit: formHandler(
      async () => {
        await apiClient.post(endpoints.LogisticsKR.railwaysRates(), formik.values)
      },
      {
        onSuccess: async () => {
          await refetch()
          onClose()
        },

        onError: (err) => {
          const error = err as RequestError
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })

  return (
    <ASharedModal id="createRailwayTarif" size="medium" onClose={onClose}>
      <SharedModalTitle>{t('modal.heading')}</SharedModalTitle>

      <RailsModalContent formik={formik} />

      <ADefaultModalFooter
        confirmButtonText={t('common:save')}
        onClose={onClose}
        onConfirm={() => formik.submitForm()}
        progress={formProgress}
      />
    </ASharedModal>
  )
}
